// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"240":"86a7875f","308":"13c86f9f","430":"8fd4e5db","620":"0c04db7f","737":"afb211e1"}[chunkId] + ".chunk.css";
};